import { CustomAPI } from '@sydle/ui-api';
import { downloadRichContent } from './download-rich-content';
import { getCategories } from './get-categories';
import { getPageLinks } from './get-page-links';
import { getPost } from './get-post';
import { getPosts } from './get-posts';
import { registerUserConsents } from './register-user-consents';
import { sendSuggestion } from './send-suggestion';

const blogFacade = {
  getCategories,
  getPageLinks,
  getPost,
  getPosts,
  downloadRichContent,
  registerUserConsents,
  sendSuggestion,
};

const BLOG_API_CLASS_ID = '64e3762ca92c2f3752cb7f6a';

export const blogCustomAPI = new CustomAPI(BLOG_API_CLASS_ID);

export function createBlogAPI(): void {
  if (typeof window !== 'undefined') {
    window.blogFacade = blogFacade;
  }
}

export type BlogFacade = typeof blogFacade;
